module.exports = __webpack_public_path__ + "img/60m6.d5fff043.jpg";